import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import { VBToggle } from 'bootstrap-vue'
import VuePictureSwipe from 'vue-picture-swipe';
import UUID from 'vue-uuid'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'

// Custom directives and permissions
import Can from '@/UserPermissions/v-can_Directive'
import Permissions from '@/UserPermissions/PermissionGroups'

// v-can, will check if all entered permissions exists on the user
Vue.directive('can', Can.CanDirective)
Vue.directive('can-read', Can.CanDirective)
Vue.directive('can-delete', Can.CanDirective)
Vue.directive('can-publish', Can.CanDirective)
Vue.directive('can-write', Can.CanDirective)
// can-read, can-delete.... are just a different more readable way to write it than can. All above does the same thing. All below does the same thing
// v-can-any, will check if any permission exists on the user
Vue.directive('can-any', Can.CanAnyDirective)
Vue.directive('can-read-any', Can.CanAnyDirective)
Vue.directive('can-delete-any', Can.CanAnyDirective)
Vue.directive('can-publish-any', Can.CanAnyDirective)
Vue.directive('can-write-any', Can.CanAnyDirective)

Vue.prototype.$permissions = Permissions.Permissions
Vue.prototype.$permissionGroup = Permissions.PermissionGroups
Vue.prototype.$accessGroup = Permissions.ReadingGroups

Vue.prototype.$currentUserId = () => JSON.parse(localStorage.getItem('user')).user.id;

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.directive('b-toggle', VBToggle)
Vue.component('vue-picture-swipe', VuePictureSwipe);


// Composition API
Vue.use(VueCompositionAPI)
Vue.use(UUID)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false
Vue.config.silent = true

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
